/**
 * @file defined a map that maps the states and their comments.
 * e.g. the value of 'comment.enableTracing' is the comment that need to be put right above the corresponding variable of 'EnableTracing' in the Response File
 * @author Haonan Yu(haoyu@microStrategy.com)
 */

const comment = {};

comment.enableTracing = `
[Installer]
`;


comment.hideWelcomeDialog = `
[Welcome]
`;

comment.removeAll = `###  For silent uninstall, set RemoveAll=TRUE ###
`;


comment.hideSummaryDialog = `
[Summary]
`;


comment.hideFinishDialog = `
[Finish]
`;

export default comment;